/**
 *
 * The app duck. These are actions for controlling the application. I.E. Things
 * like initialization and the window being available for client-side activity.
 *
 * Action Types:
 * - INIT
 * - WINDOW_AVAILABLE
 *
 * Action Creators:
 * - initialize
 * - windowAvailable
 */

import type { Action, Initialize } from '../types';

/** @type {ActionType} */
export const INIT = 'PB/app/INIT';
export const WINDOW_AVAILABLE = 'PB/app/WINDOW_AVAILABLE';
export const STORED_STATE_RETRIEVED = 'PB/app/STORED_STATE_RETRIEVED';

export function initialize(): Initialize {
  return {
    type: INIT,
  };
}

export function windowAvailable(): Action {
  return {
    type: WINDOW_AVAILABLE,
  };
}

// TODO: This likely can be replaced by 'persist/REHYDRATE'
export function storedStateRetreived(storedState): Action {
  return {
    type: STORED_STATE_RETRIEVED,
    payload: storedState,
  };
}
